import { DocumentSmall } from '@blueprint/icons';
import { Heading2 } from '@blueprint/ui';
import React from 'react';
import { CTALink } from 'listing-details/components/CTA/CTA';
import { AdditionalLinksWrapper } from './AdditionalLinks.styles';
import { trackAdditionalLink } from './AdditionalLinks.tracking';
import { AdditionalLinksProps } from './AdditionalLinks.types';
import { mapLinksToCTAs } from './AdditionalLinks.helpers';

const AdditionalLinks = ({
    data: { additionalLinks }
}: AdditionalLinksProps) => {
    const links = mapLinksToCTAs(additionalLinks);

    if (!links) {
        return <></>;
    }

    return (
        <AdditionalLinksWrapper data-testid="additional-links">
            <Heading2 size="6">Additional links</Heading2>
            {links.map(({ label, href }) => (
                <CTALink
                    key={href}
                    icon={<DocumentSmall />}
                    label={label}
                    target="_blank"
                    href={href}
                    onClick={() => trackAdditionalLink(label)}
                ></CTALink>
            ))}
        </AdditionalLinksWrapper>
    );
};

export default AdditionalLinks;
